import React, {useState} from 'react';
import styles from '../styles/audio.module.css';
import WavesurferPlayer from '@wavesurfer/react';
import { useMediaQuery } from 'react-responsive';

const AudioPlayer = ({...props}) => {
    const [wavesurfer, setWavesurfer] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const isTablet = useMediaQuery({
        query: '(max-width: 800px)'
    })

    const isMobile = useMediaQuery({
        query: '(max-width: 600px)'
    })
  
    const onReady = (ws) => {
      setWavesurfer(ws)
      setDuration(ws.getDuration());
      setIsPlaying(false);
  
      // Update the current time as the audio plays
      ws.on('audioprocess', () => {
        setCurrentTime(ws.getCurrentTime());
      });
  
      // Update the duration if the audio file changes
      ws.on('ready', () => {
        setDuration(ws.getDuration());
      });
    }
  
    const onPlayPause = () => {
      wavesurfer && wavesurfer.playPause()
    }

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
        <>
            <h1 className={styles.title}>{props.title}</h1>
            <span className={styles.composer}>{props.by}</span>
            <div className={styles.player}>
                <button className={styles.playerButton} onClick={onPlayPause}>
                {isPlaying ? 'Pause' : 'Play'}
                </button>
                <span>{formatTime(currentTime)}</span>
                <WavesurferPlayer
                height={isMobile ? 75 : 100}
                width={isTablet ? isMobile ? 120 : 300 : 500}
                audioRate={props.rate}
                barRadius={10}
                barWidth={isMobile ? 3 : 5}
                barGap={isTablet ? isMobile ? 10 : 7 : 5}
                waveColor="rgb(172, 255, 47)"
                progressColor="#00c2cb"
                dragToSeek
                url={props.track}
                onReady={onReady}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                />
                <span>{formatTime(duration)}</span>
            </div>
          </>
    );
};
    
export default AudioPlayer;